import { format, formatDistanceToNow } from 'date-fns';
import { useUiStore } from '@/stores/UiStore.ts';
import { enGB, nlBE } from 'date-fns/locale';
import { i18n } from '@/i18n';

export function formatWithLocale(date: Date, formatStr: string): string {
  return format(date, formatStr, getLocaleAsOptions());
}
export function formatAsDate(date: Date): string {
  return format(date, 'yyyy-MM-dd', getLocaleAsOptions());
}

export function formatAsDateTime(date: Date): string {
  return format(date, 'yyyy-MM-dd HH:mm', getLocaleAsOptions());
}

export function formatRelativeToNow(date: Date): string {
  const suffixOption = { addSuffix: true };
  const options = { ...getLocaleAsOptions(), ...suffixOption };

  return formatDistanceToNow(date, options);
}

export function capitalizedShortMonthName(time: Date) {
  const key = 'primevue.monthNamesShort';
  const mns = i18n.global.tm(key)[time.getMonth()];
  return mns.charAt(0).toUpperCase() + mns.slice(1);
}

function getLocaleAsOptions(): object {
  return { locale: getLocaleFromStore() };
}

function getLocaleFromStore() {
  const localeDict = {
    nl: nlBE,
    en: enGB,
  };

  try {
    return localeDict[useUiStore().locale];
  } catch {
    return enGB;
  }
}
